module.exports = __webpack_public_path__ + "fonts/done.c62abfeca3e060aa31ce.svg";